import { render, staticRenderFns } from "./boq-link-manager.vue?vue&type=template&id=7f996d63&scoped=true"
import script from "./boq-link-manager.vue?vue&type=script&lang=js"
export * from "./boq-link-manager.vue?vue&type=script&lang=js"
import style0 from "./boq-link-manager.vue?vue&type=style&index=0&id=7f996d63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f996d63",
  null
  
)

export default component.exports